import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M11.0012 4.37866L3.37988 12L11.0012 19.6213L13.1225 17.5L9.12252 13.5H22.0012V10.5H9.12253L13.1225 6.49999L11.0012 4.37866Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeft;
